





























import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class ButtonProfile extends Vue {

    @Prop(String) firstName!: string
    @Prop(String) lastName!: string

    logout() {
        this.$auth.logout({
            redirect: '/login',
        })
        
        localStorage.removeItem('vuex')
    }
}
